/**
 * scroll.ts — keyboard-navigation scroll helper.
 *
 * `keepInView` is the instant, single-container equivalent of
 * `el.scrollIntoView({ block: "nearest" })`. The difference matters for
 * keyboard navigation: `scrollIntoView` runs the browser's own "reveal"
 * heuristic and walks EVERY scrollable ancestor (including the document, which
 * may carry `scroll-behavior: smooth`), so repeated arrow presses feel laggy and
 * step by unpredictable amounts. `keepInView` writes exactly one container's
 * `scrollTop` by the precise overflow delta — the same approach the reference
 * dropdown uses, which navigates without lag.
 *
 * Edge-aligned: if the active element overflows the top it pins to the top; if it
 * overflows the bottom it pins to the bottom; when already fully visible it does
 * nothing. Geometry is read via getBoundingClientRect so it works regardless of
 * the element's offsetParent (the list rows are not positioned relative to the
 * scroll container).
 */
export function keepInView(container: HTMLElement, el: HTMLElement): void {
  const c = container.getBoundingClientRect();
  const e = el.getBoundingClientRect();
  if (e.top < c.top) {
    container.scrollTop -= c.top - e.top; // overflow above → align top to top
  } else if (e.bottom > c.bottom) {
    container.scrollTop += e.bottom - c.bottom; // overflow below → align bottom to bottom
  }
}
